import React from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import RightSideModel from "src/components/popup/rightSide/RightSideModel";
import { allowedToCreateEntity } from "src/constants/role";
import useAuth from "src/hooks/useAuth";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import Controls from "src/components/form/controls/Controls";
import { isOpenPopup } from "src/utils/isOpenPopup";
import FLFContextDeviceForm from "../form/FLFContextForm/FLFContextDeviceForm";

const FLFContextDevicePopup = ({
  openPopup,
  setOpenPopup,
  handleOpenPopup,
  listDevice,
  setListDevice,
  clause,
  contextId,
  setContext,
}) => {
  const { auth } = useAuth();
  const permissionsAccessControl = useGetPermissionAccessControl();
  return (
    <>
      {allowedToCreateEntity(auth?.permissions, permissionsAccessControl) && (
        <Controls.Button
          text="Config"
          variant="outlined"
          startIcon={<SettingsIcon />}
          onClick={() => handleOpenPopup(isOpenPopup, null)}
        />
      )}
      <RightSideModel
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        title={`Config ${clause} Clause`}
      >
        <FLFContextDeviceForm
          listDevice={listDevice}
          setListDevice={setListDevice}
          clause={clause}
          contextId={contextId}
          setContext={setContext}
        />
      </RightSideModel>
    </>
  );
};

export default FLFContextDevicePopup;
